import { z } from "zod";

export const TOOL_HOOK_STAGES = ["tool.call", "tool.result"] as const;
export type ToolHookStage = (typeof TOOL_HOOK_STAGES)[number];

export const toolHookConfigSchema = z
	.object({
		name: z.string().regex(/^[a-z0-9][a-z0-9-]{0,62}$/),
		entry: z.string().regex(/^\.forgelab\/hooks\/[A-Za-z0-9][A-Za-z0-9._/-]{0,230}$/),
		stages: z.array(z.enum(TOOL_HOOK_STAGES)).min(1),
		mode: z.enum(["shadow", "enforce"]).default("enforce"),
		priority: z.number().int().min(-10_000).max(10_000).default(100),
		timeoutMs: z.number().int().min(1).max(1000).default(50),
	})
	.strict();

export type ToolHookConfig = z.infer<typeof toolHookConfigSchema>;

export interface PinnedToolHook extends ToolHookConfig {
	version: string;
}
